import { CSSProperties } from 'react';
import styled from 'styled-components';

import IconLocationPinMono from '@/components/atom/icon/IconLocationPinMono';
import theme from '@/styles/theme';

interface ResultSectionProps {
  title: string;
  hasResultData: boolean;
  children?: React.ReactNode;
}

const ResultSection = ({
  title,
  children,
  hasResultData,
}: ResultSectionProps) => {
  if (!hasResultData) return <></>;

  return (
    <Wrapper>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </Wrapper>
  );
};

interface ResultProps {
  children: React.ReactNode;
}

const Result = ({ children }: ResultProps) => {
  return <>{children}</>;
};

interface MoreButtonProps {
  onClick: () => void;
  style?: CSSProperties;
}

const MoreButton = ({ onClick, style }: MoreButtonProps) => {
  return (
    <ButtonWrapper onClick={onClick} style={style}>
      <ButtonText>더보기</ButtonText>
    </ButtonWrapper>
  );
};

const ResultWrapper = ({ children }: ResultProps) => {
  return <ResultSectionWrapper>{children}</ResultSectionWrapper>;
};

interface ResultAddressProps {
  address: string;
  getCurrentLocation: () => void;
  marginTop?: number;
}

const ResultAddress = ({
  address,
  getCurrentLocation,
  marginTop = 12,
}: ResultAddressProps) => {
  return (
    <AddressWrapper marginTop={marginTop}>
      <Address>
        <IconLocationPinMono size={16} fill={theme.color.gray700} />
        {address}
      </Address>
      <Subtitle role="button" onClick={getCurrentLocation}>
        현재 위치로 설정
      </Subtitle>
    </AddressWrapper>
  );
};

ResultSection.Result = Result;
ResultSection.MoreButton = MoreButton;
ResultSection.ResultWrapper = ResultWrapper;
ResultSection.ResultAddress = ResultAddress;

export default ResultSection;

const Wrapper = styled.section`
  border-bottom: 16px solid ${({ theme }) => theme.color.gray30};
`;

const SectionTitle = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 12px;
  align-items: center;
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray500};
`;

const ButtonWrapper = styled.button`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0px;
  align-self: stretch;
  border-top: 1px solid ${({ theme }) => theme.color.gray50};
`;

const ButtonText = styled.div`
  ${({ theme }) => theme.typography.UI17M};
  color: ${({ theme }) => theme.color.gray500};
`;

const ResultSectionWrapper = styled.ul``;

const AddressWrapper = styled.div<{ marginTop: number }>`
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  height: 48px;
  display: flex;
  align-items: center;
  margin-top: ${({ marginTop }) => `${marginTop}px`};
  justify-content: space-between;
  background-color: ${({ theme }) => theme.color.gray30};
`;

const Address = styled.div`
  ${({ theme }) => theme.typography.UI14M};
  color: ${({ theme }) => theme.color.gray700};
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 6px;
  }
`;

const Subtitle = styled.span`
  ${({ theme }) => theme.typography.UI14R};
  color: ${({ theme }) => theme.color.gray300};
  text-decoration: underline;
  cursor: pointer;
`;
